import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09fd31e5")

_pushScopeId("data-v-09fd31e5")
const _hoisted_1 = { class: "content-media-library mt-4" }
const _hoisted_2 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-0" }, "Uploaded media", -1)
const _hoisted_4 = { class: "text-muted fs-8" }
const _hoisted_5 = { class: "progress h-8px w-100 mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_7 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_8 = {
  key: 2,
  class: "content-media-library__grid"
}
const _hoisted_9 = { class: "content-media-library__thumb" }
const _hoisted_10 = {
  key: 1,
  class: "content-media-library__video"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-video text-white" }, null, -1)
const _hoisted_12 = { class: "content-media-library__meta" }
const _hoisted_13 = { class: "text-muted fs-9" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.formatBytes(_ctx.usedBytes)) + " / " + _toDisplayString(_ctx.formatBytes(_ctx.limitBytes)), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", {
        class: "progress-bar",
        role: "progressbar",
        style: { width: _ctx.storagePercent + '%' },
        "aria-valuenow": _ctx.storagePercent,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, null, 12, ["aria-valuenow"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_6, "Loading media..."))
      : (!_ctx.visibleFiles.length)
        ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.imagesOnly ? "No uploaded images yet." : "No uploaded files yet."), 1))
        : (_openBlock(), _createBlock("div", _hoisted_8, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleFiles, (file) => {
              return (_openBlock(), _createBlock("div", {
                key: file.id,
                class: ["content-media-library__item", {
          'content-media-library__item--selected': _ctx.selectedIds.includes(file.id),
          'content-media-library__item--disabled': !_ctx.canAttach(file)
        }],
                onClick: ($event: any) => (_ctx.toggleAttach(file))
              }, [
                _createVNode("div", _hoisted_9, [
                  (_ctx.isImage(file))
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: file.publicUrl,
                        alt: file.originalFilename
                      }, null, 8, ["src", "alt"]))
                    : (_openBlock(), _createBlock("div", _hoisted_10, [
                        _hoisted_11
                      ])),
                  _createVNode("span", {
                    class: ["badge content-media-library__status", _ctx.statusClass(file.status)]
                  }, _toDisplayString(file.status), 3)
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", {
                    class: "text-truncate fs-8 fw-semibold",
                    title: file.originalFilename
                  }, _toDisplayString(file.originalFilename), 9, ["title"]),
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formatBytes(file.fileSizeBytes)), 1)
                ]),
                (!_ctx.readOnly)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm btn-light content-media-library__delete",
                      title: "Delete",
                      onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(file)), ["stop"])
                    }, [
                      _hoisted_14
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 10, ["onClick"]))
            }), 128))
          ]))
  ]))
})